import axios from 'axios';
import {
    API
} from '../../index';

// Types
/**
 * @typedef ReportRequestParam
 * @property {number} reportParamId
 * @property {any} value
 */

/**
 * POSTs new report request
 * @param {number} reportId
 * @param {ReportRequestParam[]} params
 */
export const createReportRequest = (reportId, params) => (dispatch, geState) => {
    return new Promise((resolve, reject) => {
        const store = geState();

        return axios.post(API + 'report-request', {
            reportId: reportId,
            params: params,
        }, {
            headers: {
                'Authorization': store.auth.token,
            },
        }).then(response => {
            return resolve(response);
        }).catch(error => {
            return reject(error);
        });
    });
}



// WEBPACK FOOTER //
// ./app/web/src/container/RequestReportPage/action.js